import moment from 'moment';

export const isNewYearDiscountEnabled =
  moment() >=
    moment(
      process.env.REACT_APP_NEW_YEAR_DISCOUNT_START_DATE_2026,
      'YYYY-MM-DD'
    ).startOf('day') &&
  moment() <=
    moment(
      process.env.REACT_APP_NEW_YEAR_DISCOUNT_END_DATE_2026,
      'YYYY-MM-DD'
    ).endOf('day');

export const calculateDiscountData = (minutes: number, amount: number) => {
  let discountPercentage: number | undefined;
  let percentageAmount: number | undefined;

  if (minutes >= 60 * 60) {
    discountPercentage = 10;
    percentageAmount = (amount * discountPercentage) / 100;
  } else if (minutes >= 30 * 60) {
    discountPercentage = 7;
    percentageAmount = (amount * discountPercentage) / 100;
  } else if (minutes >= 15 * 60) {
    discountPercentage = 5;
    percentageAmount = (amount * discountPercentage) / 100;
  }

  return {
    percentage: discountPercentage,
    discountAmount: percentageAmount,
  };
};

export const getNewYearDiscountAmountData = (data: {
  userRegistrationDate: string;
  amount: number;
  packageMinutes?: number;
  noDefault?: boolean;
}) => {
  const { userRegistrationDate, amount, packageMinutes, noDefault } = data;

  if (!userRegistrationDate) return undefined;

  let newAmount = amount;
  let previousAmount: number | undefined;
  let discountPercentage: number | undefined;
  let percentageAmount = (amount * 10) / 100; // default 10 percent

  const userRegistrationDateMoment = moment(userRegistrationDate);
  const minDate = moment(
    process.env.REACT_APP_NEW_YEAR_DISCOUNT_START_DATE_2026,
    'YYYY-MM-DD'
  ).startOf('day');

  const maxDate = moment(
    process.env.REACT_APP_NEW_YEAR_DISCOUNT_END_DATE_2026,
    'YYYY-MM-DD'
  ).endOf('day');

  const isInRange = userRegistrationDateMoment.isBetween(
    minDate,
    maxDate,
    undefined,
    '[]'
  );

  if (isNewYearDiscountEnabled) {
    if (isInRange) {
      previousAmount = amount + percentageAmount;
      newAmount = previousAmount;

      if (!noDefault) {
        newAmount = previousAmount - percentageAmount;
      }

      if (packageMinutes) {
        const { discountAmount, percentage } = calculateDiscountData(
          packageMinutes,
          previousAmount
        );

        if (discountAmount && percentage) {
          discountPercentage = percentage;
          percentageAmount = discountAmount;
          newAmount = previousAmount - discountAmount;
        }
      }
    } else if (
      userRegistrationDateMoment < minDate &&
      userRegistrationDateMoment < maxDate
    ) {
      previousAmount = amount;
      newAmount = previousAmount;

      if (!noDefault) {
        newAmount = previousAmount - percentageAmount;
      }

      if (packageMinutes) {
        const { discountAmount, percentage } = calculateDiscountData(
          packageMinutes,
          amount
        );

        if (discountAmount && percentage) {
          discountPercentage = percentage;
          percentageAmount = discountAmount;
          newAmount = previousAmount - discountAmount;
        }
      }
    }
  }

  return {
    discountPercentage,
    previousAmount,
    amount: newAmount,
  };
};

export default getNewYearDiscountAmountData;
